import {
  LOAD_MODEL,
  UPDATE_FILTER,
  RESET,
  TEMPLATE,
  CATEGORY,
  SECOND,
  UPDATE_STATS,
  ADD_FOLDER,
  ADD_TEMPLATE,
  DELETE_FOLDER,
  DELETE_TEMPLATE,
  RENAME_FOLDER,
  EDIT_TEMPLATE,
  GET_FOLDERS_COLLECTIONS,
  SAVE_COLLECTION,
  SAVE_COLLECTIONS,
  EDIT_COLLECTIONS,
  DELETE_COLLECTIONS,
  CREATE_COLLECTIONS_FOLDER,
  RENAME_COLLECTIONS_FOLDER,
  DELETE_COLLECTIONS_FOLDER,
  ADD_ACTIVE_FOLDER,
  SET_MODE_COMPARE,
  CHANGE_COLLECTION_CHECKBOX,
  SET_QUICK_INFO_COMPARE,
  CLEAR_SETTING_VIEWER
} from "../constans";
import {resizeViewer, unColorCollection} from "utils/builder/IScheduleLogic";
import {selectCollectionOnView, unselectCollectionOnView} from "../actions/collections";

const select = {
    categories: null,
    filterValues: null,
    groups: null,
    properties: null,
    secondFilter: null,
};
const initState = {
    categories: null,
    filterByOptions: null,
    filterValues: null,
    groupingOptions: [],
    properties: null,
    selection: select,
    templates: null,
    template: null,
    quickInfoCompare: null,
    compare: {
      isModeCompare: false,
      collections: {},
      selectionDetails: []
    }
};

const viewerReducer = (state = initState, { type, payload }) => {
    switch (type) {
        case LOAD_MODEL:

            const commonCategories = payload?.commonCategories;
            const uncommonCategories = payload?.uncommonCategories;

            const commonProperties = payload?.commonProperties;
            const uncommonProperties = payload?.uncommonProperties;

            const commonGroupingOptions = payload?.commonGroupingOptions;
            const uncommonGroupingOptions = payload?.uncommonGroupingOptions;

            return {
                ...state,
                ...payload,
                commonCategories,
                uncommonCategories,
                commonProperties,
                uncommonProperties,
                commonGroupingOptions,
                uncommonGroupingOptions,
                selection: select,
            };
        case RESET:

            return {
                ...initState,
                categories: state.categories,
                templates: state.templates,
                collectionsFolders: state.collectionsFolders,
                template: payload,
                templatesCount: state.templatesCount,
                commonCategories: state.commonCategories,
                uncommonCategories: state.uncommonCategories,
                templatesFolder: state.templatesFolder
            };
        case UPDATE_FILTER: {

            resizeViewer();

            const newState = {
                ...state,
                ...payload,
            }

            return {
                ...state,
                ...payload,
            };
        }
        case TEMPLATE:

            return {
                ...state,
                ...payload,
            };
        case CATEGORY: {

            resizeViewer();

            const newState = {
                ...state,
                ...payload,
                template: null,
            };

            return newState;
        }
        case SECOND:

            return {
                ...state,
                ...payload,
                selection: {
                    ...payload.selection,
                    categories: state.selection.categories,
                    secondFilter: state.selection.secondFilter,
                    filterValues: state.selection.filterValues,
                },
            };
        case UPDATE_STATS:

            var newState = { ...state };
            newState.quickCounterData = payload;
            return {
                ...state,
                ...newState,
            };
        case SET_QUICK_INFO_COMPARE:

          return {
            ...state,
            quickInfoCompare: payload,
          };
        case ADD_FOLDER:

          return {
            ...state,
            templatesFolder: {
              ...state.templatesFolder,
              [payload]: []
            }
          };
        case RENAME_FOLDER:

          const copyArray = state.templatesFolder[payload.originalName];
          const templatesFolder =  state.templatesFolder;

          delete templatesFolder[payload.originalName];

          return {
            ...state,
            templatesFolder: {
              ...templatesFolder,
              [payload.newNameFolder]: copyArray
          }
        };
      case ADD_TEMPLATE:

          const newArray = [...state.templatesFolder[payload.folder], payload.template].sort();

          return {
            ...state,
            templatesFolder: {
              ...state.templatesFolder,
              [payload.folder]: newArray
            }
          };
      case EDIT_TEMPLATE:

          const arrayWithoutOldTemplates = state.templatesFolder[payload.currentNameFolder].filter((el) => el !== payload.currentNameTemplate);

          if(payload.newNameFolder === payload.currentNameFolder) {

            const arrayWithNewTemplate = [...arrayWithoutOldTemplates, payload.newNameTemplate].sort();

            return {
              ...state,
              templatesFolder: {
                ...state.templatesFolder,
                [payload.currentNameFolder]: arrayWithNewTemplate,
              }
            };
          } else {

            const arrayWithNewTemplate = [...state.templatesFolder[payload.newNameFolder], payload.newNameTemplate].sort();

            return {
              ...state,
              templatesFolder: {
                ...state.templatesFolder,
                [payload.currentNameFolder]: arrayWithoutOldTemplates,
                [payload.newNameFolder]: arrayWithNewTemplate
              }
            };
          }
        case DELETE_FOLDER:

          const templatesFolderNew =  state.templatesFolder;

          delete templatesFolderNew[payload];

          return {
            ...state,
          };
        case DELETE_TEMPLATE:

          const templatesNew =  state.templatesFolder[payload.folderName].filter((el) => el !== payload.templateName);

          return {
            ...state,
            templatesFolder: {
              ...state.templatesFolder,
              [payload.folderName]: templatesNew
            }
          };
        case GET_FOLDERS_COLLECTIONS:

          return {
            ...state,
            collectionsFolders: payload
          };
        case SAVE_COLLECTIONS:

          return {
            ...state,
            collections: payload
          };
        case SAVE_COLLECTION:

          return {
            ...state,
            collections: payload
            };
        case CREATE_COLLECTIONS_FOLDER:

          return {
            ...state,
            collectionsFolders: [...state.collectionsFolders, payload].sort()
          };
        case RENAME_COLLECTIONS_FOLDER:

          const copyArrayCollection = state.collectionsFolders.filter((folder) => folder !== payload.originalNameFolder);

          return {
            ...state,
            collectionsFolders: [...copyArrayCollection, payload.newNameFolder]
          }
        case DELETE_COLLECTIONS_FOLDER:

          const newCollection = state.collectionsFolders.filter((folder) => folder !== payload);

          return {
            ...state,
            collectionsFolders: newCollection
          }
        case EDIT_COLLECTIONS:

          let newEditCollection = state.collections;

          if(payload.oldFolder !== payload.newFolder) {
            newEditCollection = state.collections.filter((collection) => collection.name !== payload.oldTitle);
          }

          return {
            ...state,
            collections: newEditCollection
          };
        case DELETE_COLLECTIONS:

          const newDeleteCollection = state.collections.filter((collection) => collection.creationTime !== payload.id);

          return {
            ...state,
            collections: newDeleteCollection
          };
        case ADD_ACTIVE_FOLDER:

          return {
            ...state,
            activeFolder: payload
          };
        case SET_MODE_COMPARE:

          if(payload) {
            return {
              ...state,
              compare: {...state.compare, isModeCompare: payload}
            };
          } else {

            const uncheckedCollections = state.collections.map((collection) => {
              return  {...collection, checked: false}
            });

            return {
              ...state,
              compare: {...state.compare, isModeCompare: payload, selectionDetails: [], collections: {}},
              collections: uncheckedCollections
            };
          }

        case CHANGE_COLLECTION_CHECKBOX:

          const newCollectionsCompare = {
            ...state.compare.collections,
            [payload.activeFolder]: payload.collections.map((collection) => {
              if(collection.creationTime === payload.collection.creationTime) {
                return {...collection, checked: !collection?.checked}
              } else {
                return collection
              }
            })
          }

          const newCollections = state.collections.map((collection) => {

            let checked = false;

            newCollectionsCompare[payload.activeFolder].map((collectionCompare) => {
              if (collection.creationTime === collectionCompare.creationTime) {
                checked = collectionCompare.checked;
              }
            })

            return {...collection, checked}
          })

          const isCollectionDetails = state.compare.selectionDetails.some((el) => el.id === payload.selectionDetails.id);
          let newSelectionDetails = state.compare.selectionDetails;

          if(isCollectionDetails) {
            newSelectionDetails = state.compare.selectionDetails.filter((el) => el.id !== payload.selectionDetails.id);
          } else {
            newSelectionDetails.push(payload.selectionDetails);
          }

          const selectElements = Object.values(newCollectionsCompare).flat(2).filter((el) => el.checked);
          selectCollectionOnView(selectElements);

          return {
            ...state,
            compare: {...state.compare, collections: newCollectionsCompare, selectionDetails: newSelectionDetails},
            collections: newCollections,
          };
        case CLEAR_SETTING_VIEWER:
            return initState
        default:
            return state;
    }
};
export default viewerReducer;
